import { IRootState } from "../../store";

export const selectLanguages = (state: IRootState) => state.languages.languages;
export const selectCurrentLang = (state: IRootState) =>
  state.languages.currentLang;
